import { getRequestEvent } from 'solid-js/web';

const TEMPORARY_REDIRECT = 307;

export const renderContext = {
  pageUrl: (): string | undefined => {
    if (typeof window === 'undefined') {
      return getRequestEvent()?.request.url;
    }
    return window.location.href;
  },
  redirect: (url: string): void => {
    const response = getRequestEvent()?.response;
    if (!response) {
      return;
    }
    response.status = TEMPORARY_REDIRECT;
    response.headers.set('Location', url);
  },
};
